export default {
  QQ_CLIENT_ID: "102042346",
  QQ_REDIRECT_URL: "https://ai.seayouth.xyz/callback/qq",
  GITEE_CLIENT_ID: "d04bf1257cfd712c25100cf096be795aaf10a6b1cd2928def2a9d51725c9a40a",
  GITEE_REDIRECT_URL: "https://ai.seayouth.xyz/callback/gitee",
  WEIBO_CLIENT_ID: "2285022919",
  WEIBO_REDIRECT_URL: "https://ai.seayouth.xyz/callback/weibo",
};
